import React from "react";

const StatusGridCards = ({ title, count, bgColor, Icon, iconColor, onClick}) => {
  return (
    <div className="status-card" style={{ background: bgColor }} onClick={onClick}>
      <div className="card-top">
        <div className="wo-count">{count}</div>
        <div className="wo-icon">
          {Icon && <Icon size={15} color={iconColor}/>}
        </div>
      </div>
      <div className="grid-label">
        <p>{title}</p>
      </div>
    </div>
  );
};

export default StatusGridCards;